import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Spin, Input } from 'antd';
import { Formik } from 'formik';
import { useSelector } from 'react-redux';

import palette from 'palette';
import { FormikInputFieldWithLabel } from 'elements/FormikInputFieldWithLabel';
import { FormikCheckboxWithLabel } from 'elements/FormikCheckboxWithLabel';
import adminSelectors from 'store/admin/selectors';
import { ConnectionType, ConnectorBase, ConnectorsFieldName } from 'pages/Connectors/types';
import { SelectConnectionType } from 'pages/Connectors/SelectConnectionType';
import { createConnectorValidationSchema } from './validation-schema';
import { StyledButtons, StyledContentForm, StyledEditBlock } from './styles';

const { TextArea } = Input;

interface CreateContentProps {
  onSubmitForm: (values: ConnectorBase) => void;
}

export const CreateContent: FC<CreateContentProps> = ({ onSubmitForm }) => {
  const isCreateGroupLoading = useSelector(adminSelectors.groups.isCreateGroupLoading);
  const { t } = useTranslation();

  return (
    <Formik<ConnectorBase>
      initialValues={{
        name: '',
        enabled: false,
        connectionType: ConnectionType.PUSH,
      }}
      validationSchema={createConnectorValidationSchema}
      onSubmit={(submittedValues) => {
        onSubmitForm({
          ...submittedValues,
        });
      }}
    >
      {({ values, handleChange, handleSubmit, handleReset, setFieldValue, errors }) => (
        <StyledContentForm onSubmit={handleSubmit} onReset={handleReset}>
          <Spin spinning={isCreateGroupLoading}>
            <StyledEditBlock>
              <FormikInputFieldWithLabel
                name={ConnectorsFieldName.name}
                onChange={handleChange}
                label={t('infoFields.name')}
                defaultValue={values.name}
              />
              <SelectConnectionType value={ConnectionType.PUSH} onChange={handleChange} />
            </StyledEditBlock>
          </Spin>
          <StyledButtons>
            <Button htmlType="submit" style={{ color: palette.white.w1, backgroundColor: palette.blue.b1 }}>
              {t('common.apply')}
            </Button>
            <Button onClick={handleReset} style={{ color: palette.white.w1, backgroundColor: palette.red.r3 }}>
              {t('common.cancel')}
            </Button>
          </StyledButtons>
        </StyledContentForm>
      )}
    </Formik>
  );
};
